import { render } from "./BadRequest.vue?vue&type=template&id=14406af3&scoped=true"
import script from "./BadRequest.vue?vue&type=script&lang=js"
export * from "./BadRequest.vue?vue&type=script&lang=js"

import "./BadRequest.vue?vue&type=style&index=0&id=14406af3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14406af3"]])

export default __exports__